import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import path from 'path-browserify';
import { stringify as toQuery } from 'query-string';

// DEFAULTS
const DEFAULT_REQUEST_TIMEOUT = 15 * 1000;

let apiUrl;
let sessionToken;
let flashMessageHandler;
let globalErrorHandler: ((error: AxiosError) => void) | undefined;

export function parseApiError(error) {
    return error.response ? error.response.data.error : error;
}

function getRequestConfig(): AxiosRequestConfig {
    const config: AxiosRequestConfig = {
        timeout: DEFAULT_REQUEST_TIMEOUT,
    };

    if (sessionToken) {
        config.headers = { 'X-Session': sessionToken };
    }

    return config;
}

function handleResponse(response) {
    if (flashMessageHandler && response.data.messages) {
        flashMessageHandler(response.data.messages);
    }

    return response.data.data;
}

function handleError(error: AxiosError): void {
    if (globalErrorHandler) {
        return globalErrorHandler(error);
    } else {
        throw error;
    }
}

export default {
    setApiUrl: (url) => (apiUrl = url),
    setFlashMessageHandler: (handler) => (flashMessageHandler = handler),
    setGlobalErrorHandler: (handler: (error: AxiosError) => void) => (globalErrorHandler = handler),
    setSessionToken: (token) => (sessionToken = token),

    get: (resource, params = {}, requestConfig?: AxiosRequestConfig) => {
        const query = toQuery(params);
        const url = apiUrl + path.join('/', resource) + (query ? '?' + query : '');
        return axios
            .get(url, { ...getRequestConfig(), ...requestConfig })
            .then(handleResponse)
            .catch(handleError);
    },
    patch: (resource, data, requestConfig?: AxiosRequestConfig) => {
        const url = apiUrl + path.join('/', resource);
        return axios
            .patch(url, data, { ...getRequestConfig(), ...requestConfig })
            .then(handleResponse)
            .catch(handleError);
    },
    post: (resource, data?, requestConfig?: AxiosRequestConfig) => {
        const url = apiUrl + path.join('/', resource);
        return axios
            .post(url, data, { ...getRequestConfig(), ...requestConfig })
            .then(handleResponse)
            .catch(handleError);
    },
    put: (resource, data, requestConfig?: AxiosRequestConfig) => {
        const url = apiUrl + path.join('/', resource);
        return axios
            .put(url, data, { ...getRequestConfig(), ...requestConfig })
            .then(handleResponse)
            .catch(handleError);
    },
    delete: (resource, params = {}, requestConfig?: AxiosRequestConfig) => {
        const query = toQuery(params);
        const url = apiUrl + path.join('/', resource) + (query ? '?' + query : '');
        return axios
            .delete(url, { ...getRequestConfig(), ...requestConfig })
            .then(handleResponse)
            .catch(handleError);
    },
};
